import MenuIcon from '@mui/icons-material/Menu';
import { Box, IconButton, SwipeableDrawer } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import NavBar from '../appNav/VerticalNavWrapper';
import UserBox, { UserBoxMdMode } from './Components/UserBox';
import { Link } from 'react-router-dom';

const HeaderWrapper = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  height: 64,
  backgroundColor: '#ffffff',
  padding: '0 24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottom: '1px solid #e2e8f0',
  zIndex: 1100,
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: { padding: '0 16px' },
}));

const Logo = styled('img')({
  height: 36,
  width: 'auto',
});

export const HeaderDesktop = ({ notifications, setNotifications }) => (
  <HeaderWrapper>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Link to="/accueil" style={{ textDecoration: 'none' }}>
        <Logo src={process.env.REACT_APP_LOGO_URL} alt="Logo" />
      </Link>
    </Box>
    <UserBox notifications={notifications} setNotifications={setNotifications} />
  </HeaderWrapper>
);

export const HeaderMobile = ({ notifications, setNotifications }) => {
  const [openDrawer, setOpenDrawer] = React.useState(false);

  const toggleDrawer = (open) => (event) => {
    if (event?.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
    setOpenDrawer(open);
  };

  return (
    <HeaderWrapper>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <IconButton
          edge="start"
          onClick={toggleDrawer(true)}
          sx={{ color: '#475569' }}
        >
          <MenuIcon />
        </IconButton>
        <Logo src={process.env.REACT_APP_LOGO_URL} alt="Logo" />
      </Box>

      <UserBoxMdMode notifications={notifications} setNotifications={setNotifications} />

      <SwipeableDrawer
        anchor="left"
        open={openDrawer}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        slotProps={{ paper: { sx: { width: 'min(280px, 85vw)', height: '100%' } } }}
      >
        <Box sx={{ height: '100%' }}>
          <NavBar sideBarCollapsed={false} handleClose={() => setOpenDrawer(false)} inDrawer />
        </Box>
      </SwipeableDrawer>
    </HeaderWrapper>
  );
};

export default HeaderDesktop;
